import { connect } from "react-redux";
import {
  saveStep5,
  saveStep6,
  changeStep,
} from "../../../services/Actions/Auth";
function Step5(props) {
  function handleClick(e) {
    props.saveStep5(e.target.value);
    props.saveStep6("");
    props.changeStep(7);
  }
  return (
    <div className="Step">
      <div className="container">
        <div className="question-box" data-aos="fade-down" data-aos-delay="100">
          <h2>What is your gross income?</h2>
        </div>
        <div className="option-box">
          <button
            className="button outline"
            value="Less than 64.350€"
            onClick={handleClick}
            data-aos="fade-up"
            data-aos-delay="500"
          >
            Less than 64.350€
          </button>
          <button
            className="button outline"
            value="More than 64.350€"
            onClick={handleClick}
            data-aos="fade-up"
            data-aos-delay="700"
          >
            More than 64.350€
          </button>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = {
  saveStep5,
  saveStep6,
  changeStep,
};

export default connect(null, mapDispatchToProps)(Step5);
